"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapImageData = void 0;
const react_1 = __importStar(require("react"));
const map_1 = require("../map");
let globalCanvasId = 0;
class FabricMapImageData extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.isRendered = false;
        this.canvas = document.createElement("canvas");
        this.isPowerOfTwo = (x) => !(x & (x - 1)) && !!x;
        this.resetCanvas = () => {
            const { imageData } = this.props;
            this.canvas.remove();
            this.canvas = document.createElement("canvas");
            this.canvas.style.display = "none";
            this.canvas.id = `raster-canvas-${++globalCanvasId}`;
            this.canvas.width = imageData.width;
            this.canvas.height = !this.isPowerOfTwo(imageData.height)
                ? imageData.height
                : imageData.height + 1;
            const ctx = this.canvas.getContext("2d");
            ctx.putImageData(imageData, 0, 0);
        };
        this.addRasterToMap = () => {
            var _a, _b;
            const { map, bounds } = this.props;
            this.resetCanvas();
            map.addSource(`${this.canvas.id}-source`, {
                type: "canvas",
                canvas: this.canvas,
                coordinates: [
                    [bounds.west, bounds.north],
                    [bounds.east, bounds.north],
                    [bounds.east, bounds.south],
                    [bounds.west, bounds.south],
                ],
                animate: false,
            });
            map.addLayer({
                id: `${this.canvas.id}-layer`,
                source: `${this.canvas.id}-source`,
                type: "raster",
                paint: Object.assign({ "raster-resampling": "nearest" }, this.props.rasterPaintOptions),
            }, this.props.before);
            (_b = (_a = this.props).onRender) === null || _b === void 0 ? void 0 : _b.call(_a, `${this.canvas.id}-layer`);
        };
        this.removeRasterFromMap = () => {
            const { map } = this.props;
            if (map &&
                map.getStyle() &&
                map.getSource &&
                map.getSource(`${this.canvas.id}-source`)) {
                map.removeLayer(`${this.canvas.id}-layer`);
                map.removeSource(`${this.canvas.id}-source`);
            }
        };
        this.componentDidUpdate = (prevProps) => {
            var _a;
            /**
             * Only re-render if the image has actually changed.
             */
            if (((_a = prevProps === null || prevProps === void 0 ? void 0 : prevProps.imageData) === null || _a === void 0 ? void 0 : _a.data) !== this.props.imageData.data) {
                this.removeRasterFromMap();
                this.addRasterToMap();
            }
        };
        this.render = () => {
            if (!this.isRendered) {
                this.addRasterToMap();
                this.isRendered = true;
            }
            return react_1.default.createElement(react_1.default.Fragment, null);
        };
    }
    componentWillUnmount() {
        this.removeRasterFromMap();
        this.canvas.remove();
        this.canvas = undefined;
    }
}
exports.FabricMapImageData = FabricMapImageData;
exports.default = (0, map_1.withMap)(FabricMapImageData);
